import SideMenuOptionsIfd from './SideMenuOptionsIfd';

export default SideMenuOptionsIfd;
